<section class="detail-card">
  <h4>Event Combinations</h4>
  <div class="event-combinations-grid">
    <label
      class="combination-checkbox"
      *ngFor="let combinationField of config.eventCombinationFields"
    >
      <input
        type="checkbox"
        [(ngModel)]="collector.eventCombinations[combinationField]"
        [ngModelOptions]="{ standalone: true }"
        [disabled]="readOnly"
        (ngModelChange)="emitChange()"
      />
      <span>{{ combinationField }}</span>
    </label>
  </div>
</section>
